import React from 'react';
import '../App.css'; 

const Stripes = () => {
  // Define words for the marquee in the orange and white stripes
  const orangeWords = ["CORELFLOWFIT", "MOBILITY", "BODYWEIGHT", "BREATHWORK"];
  const whiteWords = ["CORELFLOWFIT", "MOBILITY", "BODYWEIGHT", "BREATHWORK"];

  // Helper function to repeat words for the marquee effect
  const repeatWords = (words, count) => {
    let repeated = [];
    for (let i = 0; i < count; i++) {
      repeated = [...repeated, ...words];
    }
    return repeated;
  };

  return (
    <div className="strip-wrapper">
      {/* Orange Stripe */}
      <div className="strip orange">
        <div className="marquee">
          {repeatWords(orangeWords, 10).map((word, i) => (
            <span key={i}>{word}</span>
          ))}
        </div>
      </div>

      {/* White Stripe */}
      <div className="strip white">
        <div className="marquee">
          {repeatWords(whiteWords, 10).map((word, i) => (
            <span key={i}>{word}</span>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Stripes;
